function userCreateValidation() {
  const emailInput = document.querySelector('.emailValidate');

  emailInput.addEventListener('blur', function () {
    checkUserEmailExists(emailInput.value, emailInput);
  });
}

function checkUserEmailExists(email, emailInput) {
  const errorDiv = document.getElementById('emailError');

  $.ajax({
    type: 'POST',
    url: '/api/user/check',
    data: {
      email: email,
    },
    success: function () {
      errorDiv.classList.add('is-hidden');
      emailInput.classList.remove('is-danger');
    },
    error: function () {
      errorDiv.classList.remove('is-hidden');
      emailInput.classList.add('is-danger');
    },
  });
}
